module.exports = __webpack_public_path__ + "img/955d2f975523a5150c87db74ddqi--tsvety-i-floristika-tsvetochnyj-gorshok.jpg";